import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer, { reducers } from '../reducers';
import createLogger from 'redux-logger';

export default function configureStore(initialState) {
    const store = createStore(
        rootReducer,
        initialState,
        compose(
            applyMiddleware(thunk, createLogger())
        )
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            const nextRootReducer = reducers.default;
            store.replaceReducer(nextRootReducer);
        });
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/client/store/configureStore.dev.js